import React, { useState, useRef, useEffect } from 'react';
import { TaskPriority } from '../../types';

const PRIORITY_LABELS: Record<TaskPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  urgent: 'Urgent',
};

const ALL_PRIORITIES: TaskPriority[] = ['low', 'medium', 'high', 'urgent'];

interface PriorityBadgeProps {
  priority: TaskPriority;
  onChange?: (p: TaskPriority) => void;
  readonly?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, onChange, readonly, onOpenChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    onOpenChange?.(open);
  }, [open, onOpenChange]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        className="pm-priority-badge"
        onClick={() => !readonly && onChange && setOpen(!open)}
        style={{ cursor: onChange && !readonly ? 'pointer' : 'default' }}
      >
        <span className="pm-priority-dot" data-priority={priority} />
        {PRIORITY_LABELS[priority]}
      </div>
      {open && (
        <div className="pm-dropdown">
          {ALL_PRIORITIES.map(p => (
            <button
              key={p}
              className="pm-dropdown-item"
              onClick={() => { onChange?.(p); setOpen(false); }}
            >
              <span className="pm-priority-dot" data-priority={p} />
              {PRIORITY_LABELS[p]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PriorityBadge;
